import "./index.css";
function Navbar() {

    return (
        <div className="Navbar">
            <span>Java</span>
        </div>
    );
}

export default Navbar;
